import { Model, Store } from 'store/Base';
import { observable } from 'mobx';
import { Sprint } from 'store/planning/Sprint';
import { User } from 'store/User';

export class SprintAssignment extends Model {
    static backendResourceName = 'sprint_assignment';

    @observable id = null;
    @observable sprint = this.relation(Sprint);
    @observable user = this.relation(User);
    @observable plannedHours = 0;
}

export class SprintAssignmentStore extends Store {
    Model = SprintAssignment;
    static backendResourceName = 'sprint_assignment';
}
